import { StateCreator } from 'zustand'

export interface ThemeSlice {
  theme: {
    mode: 'light' | 'dark'
    primary: string
    secondary: string
    toggleTheme: () => void
    setTheme: (mode: 'light' | 'dark') => void
    setPrimaryColor: (color: string) => void
    setSecondaryColor: (color: string) => void
  }
}

export const createThemeSlice: StateCreator<ThemeSlice> = (set) => {
  // Initialize theme on document - solo una clase
  document.documentElement.classList.add('dark')
  document.documentElement.classList.remove('light')
  
  return {
    theme: {
      mode: 'dark',
      primary: '#8b5cf6',
      secondary: '#06b6d4',
      
      toggleTheme: () => {
        set((state) => {
          const newMode = state.theme.mode === 'dark' ? 'light' : 'dark'
          
          // CORREGIDO: Solo aplicar una clase a la vez
          if (newMode === 'dark') {
            document.documentElement.classList.add('dark')
            document.documentElement.classList.remove('light')
          } else {
            document.documentElement.classList.add('light')
            document.documentElement.classList.remove('dark')
          }
          
          return {
            theme: {
              ...state.theme,
              mode: newMode,
            },
          }
        })
      },
      
      setTheme: (mode: 'light' | 'dark') => {
        set((state) => {
          // CORREGIDO: Solo aplicar una clase a la vez
          if (mode === 'dark') {
            document.documentElement.classList.add('dark')
            document.documentElement.classList.remove('light')
          } else {
            document.documentElement.classList.add('light')
            document.documentElement.classList.remove('dark')
          }
          
          return {
            theme: {
              ...state.theme,
              mode,
            },
          }
        })
      },
      
      setPrimaryColor: (color: string) => {
        set((state) => ({
          theme: {
            ...state.theme,
            primary: color,
          },
        }))
      },
      
      setSecondaryColor: (color: string) => {
        set((state) => ({
          theme: {
            ...state.theme,
            secondary: color,
          },
        }))
      },
    },
  }
}